import {h} from 'preact';
import {TableRow} from './TableRow';
import {TableTitles} from './TableTitles';
import {Product} from './Product';
import {CalculatorProduct} from '../types';

type ProductsTableProps = {
  items: CalculatorProduct[];
}

// TODO: delete after inmplementing real logic
// const mockProducts = data.business.kits[2].vendors[0].products;

function ProductsTable({items}: ProductsTableProps) {
  return (
    <>
      <p>Дополнительное оборудование</p>
      <form className="kits__table" >
        <TableTitles firstColTitle="Оборудование" secondColTitle="Стоимость" />
          {
            items.map(
              (product, i) => ( 
                <TableRow> 
                  <Product id={i} item={product} /> 
                </TableRow>
              )
            )
          }

      </form>
    </>
  )
}

export {ProductsTable};
